import { render, staticRenderFns } from "./JdsJobTileListLayout.vue?vue&type=template&id=2117f119&scoped=true&"
import script from "./JdsJobTileListLayout.vue?vue&type=script&lang=ts&"
export * from "./JdsJobTileListLayout.vue?vue&type=script&lang=ts&"
import style0 from "./JdsJobTileListLayout.vue?vue&type=style&index=0&id=2117f119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2117f119",
  null
  
)

export default component.exports